<template>
    <div class="modal">
        <div class="modal-content">
            <div class="modal-header">
                <div class="modal-header-title">
                  <span>{{Language.say(props.title)}}</span>
                </div>
                <div @click="onClickClose()" class="modal-header-close" id="modal-close"><span></span></div>
            </div>

            <slot name="pre-body"> </slot>

            <div class="modal-body"  v-smart-render-scroll>
                <slot v-if="section_state.loading[section_state_id]">
                  <div class="modal-body"  v-smart-render-scroll>
                      <ContentLoading/>
                  </div>
                </slot>

                <ContentError v-if='section_state.error[section_state_id]'
                  @contentErrorRetry="onContentError()"
                />
                <slot name="body" v-if="section_state.loaded[section_state_id]">

              </slot>

            </div>
            <slot name="post-body"> </slot>

            <div class="modal-footer clearfix">
                <slot name="footer"> </slot>
            </div>
        </div>
    </div>
</template>

<script setup>
  import {defineEmits, defineExpose, defineProps} from "vue";
  import {onBeforeMount, onUnmounted}             from "vue";
  import ContentLoading                           from "@/vue/Elements/Content/ContentLoading.vue";
  import ContentError                             from "@/vue/Elements/Content/ContentError.vue";
  import KeyboardController                       from "@/js/Webmail/Keyboard/KeyboardController";
  import { KeyboardProfile }                      from "@/js/Webmail/Keyboard/KeyboardMetadata";
  import Language                                 from "@/js/Shared/Language/Language";

  const props = defineProps({
    section_state : {
      required: true,
    },

    section_state_id : {
      required: true,
    },

    title : {
      default: '',
    },
  })

  onBeforeMount(() => {
    KeyboardController.disableAll();
    KeyboardController.create(KeyboardProfile.SIMPLE_MODAL, {
      close : onKeyEscape,
    })
  });

  onUnmounted(() => {
    KeyboardController.delete(KeyboardProfile.SIMPLE_MODAL);
    KeyboardController.enableAll();
  });

  const emit = defineEmits([
    'modalWindowClose', 'errorRetry',
  ]);

  const onContentError = () => {
    emit('errorRetry');
  }

  const onKeyEscape = () => {
    close();
  }

  const onClickClose = () => {
    close();
  }

  const close = () => {
    emit('modalWindowClose')
  }

  defineExpose({
    close,
  });
</script>